export enum DemandSendToInternalErpStatus {
    UNUSED = 'UNUSED',
    POREQUEST = 'POREQUEST',
    UNWANTED = 'UNWANTED',
}
